import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import DataTable from '@/components/functional/DataTable/DataTable';
import { useUsers } from '@/api/useUsers';

const AdminUsersPage = () => {
  const { searchQuery } = useOutletContext<{ searchQuery: string }>();
  const { data: users = [], isLoading } = useUsers();

  const filteredUsers = useMemo(() => {
    if (!searchQuery) return users;
    const q = searchQuery.toLowerCase();
    return users.filter(u =>
      (u.name?.toLowerCase().includes(q)) ||
      u.user_type.toLowerCase().includes(q)
    );
  }, [users, searchQuery]);

  const columns = [
    { header: 'Name', accessorKey: 'name', cell: ({ row }: any) => row.original.name || '—' },
    { header: 'Role', accessorKey: 'user_type', cell: ({ row }: any) => (
      <span className={`px-3 py-1 rounded-full text-xs font-medium ${
        row.original.user_type === 'admin' 
          ? 'bg-purple-100 text-purple-700' 
          : 'bg-blue-100 text-blue-700'
      }`}>
        {row.original.user_type === 'admin' ? 'Admin' : 'User'}
      </span>
    )},
    { header: 'Created', accessorKey: 'created_at', cell: ({ row }: any) => 
      new Date(row.original.created_at).toLocaleDateString()
    },
  ];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-4 border-[#4E7DF6] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Users Management</h1>
      <div className="bg-white shadow rounded-lg">
        <DataTable data={filteredUsers} columns={columns} />
      </div>
    </div>
  );
};

export default AdminUsersPage;
